var React = require('react');

function NavIconsDeviceRecipes (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m21.44 5v14h-18.88v-8.39l5.64-5.61zm-1 13v-12h-11.82l-5 5v7z","key":0}),React.createElement("path",{"d":"m8.91 5.48v5.84h-5.84v-1.01h4.83v-4.83z","key":1}),React.createElement("path",{"d":"m5.55 12.64h12.87v1.01h-12.87z","key":2}),React.createElement("path",{"d":"m10.55 10.31h7.8v1.01h-7.8z","key":3}),React.createElement("path",{"d":"m10.55 7.99h7.8v1.01h-7.8z","key":4}),React.createElement("path",{"d":"m5.55 14.96h12.87v1.01h-12.87z","key":5})]);
}

NavIconsDeviceRecipes.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsDeviceRecipes;

NavIconsDeviceRecipes.default = NavIconsDeviceRecipes;
